<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="CN" id="_idParaDest-6">Chapter 4</p>
<div class="hr"><p class="CT">Rafi</p>
<p class="CIT">Lord Rafael Santiago DeSilva pressed a hand to his bleeding mouth. He’d bitten his tongue when the poacher kicked him in the face. </p>
<p class="TX">His younger brother, Dominic, handed him a linen square to wipe away the blood. “I’ve never seen a boy fight with legs and limbs flying like that.” Dom dug a leather cord out of one of his many pockets and began wrapping it around the boy’s wrist. “A tiny thing too. Look at these knobby bones. It’s pitiful enough to move me to charity.” </p>
<p class="TX">Rafi grunted. “The only charity he’ll get from me is a short rope and a long drop.”</p>
<p class="TX">The summer had been cruel to the villagers and farm folk, with an unprecedented drought razing their crops, but the amount of poaching would leave the DeSilvas’ land barren of all edible wildlife if left unchecked. Rafael would let his people hunt the animals to oblivion if he wasn’t worried about the long-lasting effects. There was no guarantee that next year’s harvest would be more abundant than this year’s. </p>
<p class="TX">“Trial first. I’ll take the evidence; you take the thief?” Rafi nodded toward the now-still deer. </p>
<p class="TX">“Giving me the heavy end of the deal, as usual,” Dom joked as he hauled the poacher upright and slung him over his shoulder. He adjusted the load and froze.</p>
<p class="TX">“Our horses aren’t that far. Surely you can carry that sack of bones a half mile.” Rafi’s forehead wrinkled in confusion as he watched Dom gently—much more gently than a poacher deserved—return the boy to the ground. “If you’d prefer the deer, then have at it. I thought to save you some bloodstained clothes, but if you insist.” </p>
<p class="TX">Rafi stepped toward the poacher’s prone form, but his brother stopped him, placing a hand at the center of Rafi’s chest. </p>
<p class="TX">“Don’t.” Dom’s face had gone pale, his lips compressed in a tight line. </p>
<p class="TX">“Why?” Rafi asked, concern beginning to churn in his belly. “That blow to the ribs couldn’t possibly have killed him.” </p>
<p class="TX">“Her.” </p>
<p class="TX">“What?” </p>
<p class="TX">Dom edged closer, as if nearing a poisonous snake. Trembling fingers turned the thief’s face to a shaft of sunlight that filtered through the branches overhead. Rafi looked past the short cap of hair and dirt-smeared cheeks. Dark eyelashes fluttered against porcelain fair skin. Pink lips parted slightly in sleep. Loose laces exposed a long slender neck, the hard slant of a collarbone and a soft mound of . . .</p>
<p class="TX">“May the Keepers steal my soul,” Rafi cursed. “It’s a girl.”</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?3d2b6404